import { render, staticRenderFns } from "./CsvTable.vue?vue&type=template&id=c6e37ff0&scoped=true&"
import script from "./CsvTable.vue?vue&type=script&lang=js&"
export * from "./CsvTable.vue?vue&type=script&lang=js&"
import style0 from "./CsvTable.vue?vue&type=style&index=0&id=c6e37ff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e37ff0",
  null
  
)

export default component.exports